import { render, staticRenderFns } from "./quick-statistics-component.vue?vue&type=template&id=c9a2fdba&scoped=true"
import script from "./quick-statistics-component.vue?vue&type=script&lang=js"
export * from "./quick-statistics-component.vue?vue&type=script&lang=js"
import style0 from "./quick-statistics-component.vue?vue&type=style&index=0&id=c9a2fdba&prod&scoped=true&lang=css"
import style1 from "./quick-statistics-component.vue?vue&type=style&index=1&id=c9a2fdba&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c9a2fdba",
  null
  
)

export default component.exports